import { useState } from 'react';

const SIGNUP_GRAPHQL_URL = '/signup/graphql';

interface SubmitResult {
  status: boolean;
  message: string;
}

interface SubmitResponse {
  data: {
    query: SubmitResult | null;
  };
  errors?: Array<{ message: string }>;
}

export async function submitSFMCData(email: string, userCountry: string): Promise<SubmitResponse> {
  const graphql = `
    query SubmitSFMCData($email: String!, $userCountry: String!) {
      query: submitSFMCData(email: $email, userCountry: $userCountry) {
        message
        status
      }
    }
  `;

  const res = await fetch(SIGNUP_GRAPHQL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: graphql,
      variables: { email, userCountry },
    }),
  });

  if (!res.ok) {
    throw new Error(`Newsletter submission failed with status ${res.status}`);
  }

  return (await res.json()) as SubmitResponse;
}

export function useSubmitSFMCData() {
  const [result, setResult] = useState<SubmitResponse | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const submissionData = async (email: string, userCountry: string) => {
    setError(null);

    try {
      const response = await submitSFMCData(email, userCountry);
      setResult(response);
      return response;
    } catch (err) {
      const submissionError = err instanceof Error ? err : new Error('Unknown error');
      setError(submissionError);
      throw submissionError;
    }
  };

  return { submissionData, resultData: result, submissionError: error };
}
